import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { FormattedMessage } from 'react-intl';
import InteractableTooltip from '../../components/interactable-tooltip';
import HelpArticleLink from '../../components/help-article-link';
import { linkIDs } from '../../services/link-service/links';
import style from './style.module.less';

const AmazonOrderTooltip = () => {
  const onclick = (e) => e.stopPropagation();

  const tooltipBodyContent = (
    <div onClick={onclick}>
      <FormattedMessage
        defaultMessage='<span>All Amazon orders that are marked as shipped will be shipped as ground for the service. Please create a label through order details to select a different service.</span><link>Learn more</link> about creating labels in ShipStation.'
        description='MarkAsShipped Amazon order tooltip text'
        id='GNqJwJ'
        values={{
          link: (chunks) => <HelpArticleLink articleId={linkIDs.CreateSingleLabels}>{chunks}</HelpArticleLink>,
          span: (chunks) => <span className={style['tooltip-text-span']}>{chunks}</span>,
        }}
      />
    </div>
  );

  const popoverBodyStyles = `
    font-size: 14px;
    padding: 10px;
    text-align: justify;
    width: 400px;
    .content-text {
      margin: 0 0 10px;
    }
  `;
  const targetWrapperStyles = style['tooltip-target-wrapper'];

  const popoverProps = {
    popoverBodyStyles,
    preferPlace: 'above',
    tooltipBodyContent,
    targetWrapperStyles,
  };

  return (
    <InteractableTooltip {...popoverProps}>
      <FontAwesomeIcon icon={faInfoCircle} />
    </InteractableTooltip>
  );
};

export default AmazonOrderTooltip;
